export interface ArticleData {
  slug: string
  title: string
  excerpt: string
  category:
    | "early-detection"
    | "technology"
    | "nutrition-lifestyle"
    | "cost-insurance"
    | "news"
  categoryLabel: string
  author: string
  authorSlug: string
  date: string
  readTime: string
  heroImage: string
  authorPhoto?: string
  cardColor: "aubergine" | "olive" | "lavender" | "white"
}

export const CATEGORIES: { id: ArticleData["category"]; label: string }[] = [
  { id: "early-detection", label: "Early detection" },
  { id: "technology", label: "Technology" },
  { id: "nutrition-lifestyle", label: "Nutrition & lifestyle" },
  { id: "cost-insurance", label: "Cost & insurance" },
  { id: "news", label: "News" },
]
